import { FilterSidebarForm } from "./filter-sidebar-form";
import { FilterSidebarHandler } from "./filter-sidebar-handler";
import { FilterSidebarListener } from "./filter-sidebar-listener";

export function initFilterSidebar(el: Element): void {
    if (!(el instanceof HTMLElement)) return;

    const form = new FilterSidebarForm(el);
    const handler = new FilterSidebarHandler();
    const listener = new FilterSidebarListener(form, handler);

    // Restore checkbox state (brand + price_range)
    handler.restoreCheckedState(form);

    // Keyword search
    const keywordSearch = form.getKeywordSearchInput();
    if (keywordSearch) {
        handler.restoreKeywordSearch(form);
        listener.registerKeywordSearch(keywordSearch, form.getKeywordClearBtn(), form.getKeywordSubmitBtn());
    }

    // Category picker
    const pickerBtn = form.getCategoryPickerBtn();
    const pickerPanel = form.getCategoryPickerPanel();
    const pickerLabel = form.getCategoryPickerLabel();
    if (pickerBtn && pickerPanel && pickerLabel) {
        const defaultLabel = pickerLabel.textContent ?? "";
        handler.restoreCategoryPickerState(form, defaultLabel);
        listener.registerCategoryPicker(
            pickerBtn,
            pickerPanel,
            form.getCategoryPickerItems(),
            pickerLabel,
            defaultLabel,
            form.getCategoryToggleButtons(),
            form.getCategoryPickerFilterInput(),
            form.getCategoryPickerGroups(),
            form.getCategoryPickerFilterClearBtn(),
        );
    }

    // Brand section toggle
    const brandToggle = form.getBrandToggle();
    const brandBody = form.getBrandBody();
    if (brandToggle && brandBody) {
        listener.registerBrandToggle(brandToggle, brandBody);
    }

    // Brand search filter
    const brandSearch = form.getBrandSearchInput();
    const brandPairs = form.getBrandItemPairs();
    if (brandSearch && brandPairs.length > 0) {
        listener.registerBrandSearch(brandSearch, brandPairs);
    }

    // Clear all filters
    const clearBtn = form.getClearButton();
    if (clearBtn) {
        listener.registerClearAll(clearBtn);
    }

    listener.registerFilterChange(el);
}
